import { useMutation } from '@tanstack/react-query';

import { UpdateUserPayload } from '../../../../../types';
import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { patchUpdateUser } from '../../requests/patchUpdateUser';

export const useUpdateUser = () => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateUser, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: UpdateUserPayload }) =>
      patchUpdateUser(constructPatch, uuid, data).then(
        (response) => response?.data,
      ),
    onSuccess: () => handleSuccess('User updated.'),
  });

  return { updateUser, ...rest };
};
